<template>
  <!-- 招租条件 -->
  <section id="qualification" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">
          承租方资格条件
        </div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="desc-block">

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">意向承租方范围</span>
        </template>
        <div>
          <template v-if="getIntentionLeaseRangeText()">
            {{ getIntentionLeaseRangeText() }}
          </template>
          <template v-else> - </template>
        </div>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label">
          <span class="desc-label-text">承租资格条件</span>
        </template>
        <div>{{ intentLeaseInfo.qualificationCondition }}</div>
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    intentLeaseInfo: {
      type: Object,
      default: () => null,
    },
    houseBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      intentionLeaseRangeList: [
        { value: 1, note: "依法设立并有效存续的企业法人" },
        { value: 2, note: "具备完全民事行为能力的自然人" },
        { value: 4, note: "个体工商户" },
        { value: 8, note: "其他经济组织" },
        { value: 16, note: "依法设立并有效存续的境内企业法人或其分支机构" },
        { value: 16384, note: "其他" },
      ],
    };
  },
  methods: {
    getIntentionLeaseRangeText() {
      let values = this.intentLeaseInfo.intentionLeaseRange;

      if (!values) return "";

      // 兼容后端返回 '["1","2"]' 这种字符串
      if (typeof values === "string") {
        try {
          values = JSON.parse(values);
        } catch (e) {
          values = [];
        }
      }

      values = values.map((item) => Number(item));

      const textList = this.intentionLeaseRangeList
        .filter((item) => values.includes(item.value))
        .map((item) => {
          if (
            item.value === 16384 &&
            this.intentLeaseInfo.intentionLeaseRangeDesc
          ) {
            return `其他：${this.intentLeaseInfo.intentionLeaseRangeDesc}`;
          }
          return item.note;
        });

      return textList.join("；");
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
}

.desc-title {
  text-align: center;
  background: #fafafa;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.desc-block /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}

.bid-mode-template {
  line-height: 28px;
  font-size: 14px;
}

.bid-mode-row {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
}

.bid-mode-row span {
  white-space: nowrap;
}
</style>